import React, { useState } from "react";
import { DatePicker, Button, message, Select, Radio } from "antd";
import { useDispatch } from "react-redux";
import { getCards } from "../store/actions/gcardAction";
import { useTranslation } from "react-i18next";
import { isTokenValid } from "../api/config";
import GcardsTable from "../tables/GcardsTable";

const Gcards = () => {
  const { t } = useTranslation();
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [paymentType, setPaymentType] = useState("");
  const [employee, setEmployee] = useState("");
  const [radioType, setRadioType] = useState("");
  const dispatch = useDispatch();
  const handelShowCard = () => {
    const token = JSON.parse(localStorage.getItem("cardsToken"));
    const filter = {
      startDate,
      endDate,
      paymentType,
      employee,
    };
    dispatch(getCards(filter))
      .unwrap()
      .then((res) => {})
      .catch((err) => {
        message.error(err, 4);
      });
    if (!isTokenValid(token)) {
      window.location.href = "/user/login";
    }
  };
  return (
    <div className="cards p-2">
      <div
        className="d-flex flexxrow flex-wrap gap-2 "
        style={{ marginBottom: 15 }}
      >
        <DatePicker.RangePicker
          placeholder={["Start date", "End date"]}
          format="DD/MM/YYYY"
          style={{ height: 40 }}
          onChange={(dates) => {
            if (dates) {
              setStartDate(dates[0].format("YYYY-MM-DD"));
              setEndDate(dates[1].format("YYYY-MM-DD"));
            } else {
              setStartDate("");
              setEndDate("");
            }
          }}
        />
        <div className="mt-1">
          <Radio.Group
          value={radioType}
          vertical
          onChange={(e) => {
            const value = e.target.value;
            setRadioType(value);
            if (value === "payment") setEmployee("");
            if (value === "employee") setPaymentType("");
          }}
        >
          <Radio value="payment" className="text-capitalize fw-bold"> {t("FORM.PAYMENTTYPE")} </Radio>
          {/* <Radio value="employee" className="text-capitalize fw-bold"> {t("FORM.EMPLOYEE")} </Radio> */}
        </Radio.Group>
        </div>
          <Select
            placeholder="Payment Type"
            disabled={!radioType}
            style={{ height: 40, width: 180 }}
            value={paymentType || undefined}
            onChange={(value) => setPaymentType(value)}
          >
            <Select.Option value="cash">{t("PAYMENTTYPE.CASH")}</Select.Option>
            <Select.Option value="card">{t("PAYMENTTYPE.CARD")}</Select.Option>
            <Select.Option value="transfer">
              {t("PAYMENTTYPE.TRANSFER")}
            </Select.Option>
          </Select>
        {/* {radioType === "employee" && (
          <Select
            placeholder="Employee"
            style={{ height: 40, width: 180 }}
            value={employee || undefined}
            onChange={(value) => setEmployee(value)}
          >
            <Select.Option value="محمود مصطفي">محمود مصطفي</Select.Option>
            <Select.Option value="أحمد جودة">أحمد جودة</Select.Option>
            <Select.Option value="سامح أمين">سامح أمين</Select.Option>
            <Select.Option value="محمد نصرالله">محمد نصرالله</Select.Option>
            <Select.Option value="أحمد راتب">أحمد راتب</Select.Option>
          </Select>
        )} */}

        <Button
          type="primary"
          style={{ height: 40, width: 100 }}
          onClick={handelShowCard}
        >
          {t("BUTTONS.SHOW")}
        </Button>
      </div>
      <GcardsTable translate={t} />
    </div>
  );
};

export default Gcards;
